import {
	AiFillGithub,
	AiFillLinkedin,
	AiFillTwitterCircle,
} from "react-icons/ai";
import Particles from "react-particles-js";
import Bounce from "react-reveal/Bounce";
import Zoom from "react-reveal/Zoom";
import Typical from "react-typical";
import profile from "../images/profile.jpg";
import Contact from "./Contact";

const Home = () => {
	const resumeDownload =
		"https://drive.google.com/uc?export=download&id=1CgUXoVDeoqFvSy9oBqTsenfqRoy74qfF";
	return (
		<div
			className="home d-flex align-items-center justify-content-center text-center"
			id="home"
		>
			<Particles
				params={{
					particles: {
						number: {
							value: 160,
							density: {
								enable: false,
							},
						},
						size: {
							value: 3,
							random: true,
							anim: {
								speed: 4,
								size_min: 0.3,
							},
						},
						line_linked: {
							enable: false,
						},
						move: {
							random: true,
							speed: 1,
							direction: "bottom",
							out_mode: "out",
						},
					},
					interactivity: {
						events: {
							onhover: {
								enable: true,
								mode: "bubble",
							},
							onclick: {
								enable: true,
								mode: "repulse",
							},
						},
						modes: {
							bubble: {
								distance: 250,
								duration: 2,
								size: 0,
								opacity: 0,
							},
							repulse: {
								distance: 400,
								duration: 4,
							},
						},
					},
				}}
			/>
			<div className="mb-3">
				<div>
					<Zoom>
						<img
							className="img-fluid rounded-circle mb-3 btn-group img-thumbnail"
							src={profile}
							alt="profile"
							loading="lazy"
						/>
					</Zoom>
					<Bounce right cascade>
						<h1 className="text-white font-weight-bold">Tamim Hossain</h1>
					</Bounce>
					<div className="btn-group">
						<Zoom>
							<h4 className="text-secondary btn-group mb-3">
								<strong>
									<Typical
										steps={[
											"Front-end Developer",
											3000,
											"React Native Developer",
											2000,
										]}
										loop={Infinity}
										wrapper="em"
									/>
								</strong>
							</h4>
						</Zoom>
					</div>
				</div>
				<div>
					<h3 className="btn-group">
						<Bounce bottom>
							<div>
								<a
									className="text-decoration-none text-white mr-4"
									href="https://www.linkedin.com/in/tamim-hossain/"
									target="_blank"
									rel="noopener noreferrer"
								>
									<AiFillLinkedin className="home-icon" />
								</a>
								<a
									className="text-decoration-none text-white mr-4"
									href="https://github.com/tamim-hossain"
									target="_blank"
									rel="noopener noreferrer"
								>
									<AiFillGithub className="home-icon" />
								</a>
								<a
									className="text-decoration-none text-white"
									href="https://twitter.com/Tamim_404"
									target="_blank"
									rel="noopener noreferrer"
								>
									<AiFillTwitterCircle className="home-icon" />
								</a>
							</div>
						</Bounce>
					</h3>
				</div>
				<div className="btn-group mt-3 mb-5">
					<div>
						<Bounce left>
							<a
								href={resumeDownload}
								target="_blank"
								rel="noopener noreferrer"
								className="btn btn-danger mr-2 font-weight-bold"
							>
								Download Resume
							</a>
						</Bounce>
					</div>
					<div>
						<Contact />
					</div>
				</div>
			</div>
		</div>
	);
};

export default Home;
